const fields_large = [
        { key: 'name', label: '案件名', width: '350' , type: 'varchar',required:true ,edit:true , view:true  ,col:6 },

        { key: "user_name", label: '担当者', view:true },

        { key:  "case_status_name", label: '進捗', view:true },
                
        { key: 'greenc_mst_corporate_name', label: '企業名', width: '350' , type: 'varchar',required:true ,edit:true , view:false  ,col:6 },

        { key: 'f49', label: '応募数', width: '350' , type: 'varchar',required:true ,edit:true , view:false  ,col:6 },

        { key: 'f50', label: '採用数', width: '350' , type: 'varchar',required:true ,edit:false , view:false  ,col:6 },

        { key: 'startdate', label: '開始日', width: '350' , type: 'date',required:false ,edit:true , view:true  ,col:6 },

        { key: 'enddate', label: '終了日', width: '350' , type: 'date',required:false ,edit:true , view:true  ,col:6 },

];

export default fields_large;



